const sendChatShareBannerMessage = (data) => {
  return new Promise((resolve) => {
    window.HiyaJSBridge.callHandler("sendChatShareBannerMessage", data, () => {
      return resolve();
    });
  });
};
export {
  sendChatShareBannerMessage
};
